import React from "react";
import {
  getMultiLineString,
  getMultiLineStringForDisplayInGrid,
} from "../platform-components/utils/common-utils";
import { getclickedParamsForAudit } from "../platform-components/utils/shared-data.service";
import moment from 'moment';
import { Button } from "@mui/material";
import { Height } from "@material-ui/icons";
import QuestionCellViewModal from "./QuestionCellViewModal";

const button = (params) => {
  return (
    <div
      // onAuditClick(params?.data.questionId, params.data.tenantId)
      data-toggle="tooltip"
      data-placement="right"
      title={getMultiLineString(params?.data?.question)}
    >
      {/* <input type='button' value='Audit' style={{ 'margin-right': '10px' }} /> */}
      {/* {getMultiLineStringForDisplayInGrid(params?.data?.question)}
       */}
      {getMultiLineString(params?.data?.question)}
    </div>
  );
};
const OptionsRenderer = (params) => {
  const getdisplayVal = () => {
    if (
      params?.data?.answers instanceof Array &&
      params?.data?.answers?.length > 0
    ) {
      // let s = '';
      // params.data.answers.forEach((ele) => {
      //   s = s + getMultiLineStringForDisplayInGrid(ele?.answer || '');
      // });
      return params.data.answers.map((ele) => ele.answer.toString()).join(", ");
    }
  };
  return (
    <div
      data-toggle="tooltip"
      data-placement="right"
      title={
        params?.value?.length
          ? params.value.map((ele) => getMultiLineString(ele.answer))
          : ""
      }
    >
      {getdisplayVal()}
    </div>
  );
};

const CommentsRenderer = (params) => {
  const getdisplayVal = () => {
    if (
      params?.data?.comments instanceof Array &&
      params?.data?.comments?.length > 0
    ) {
      let s = "";
      s =
        s +
        getMultiLineStringForDisplayInGrid(
          params.data.comments.sort(
            (e1, e2) => e2.commentId - e1.commentId
          )?.[0].comment || ""
        );
      return s;
    }
  };

  return (
    <div
      data-toggle="tooltip"
      data-placement="right"
      title={
        params?.value?.length
          ? getMultiLineString(
            params.data.comments.sort(
              (e1, e2) => e2.commentId - e1.commentId
            )?.[0]?.comment
          )
          : ""
      }
    >
      {getdisplayVal()}
    </div>
  );
};
export const columnDefs = [
  {
    headerName: "",
    field: "",
    checkboxSelection: true,
    width: 40,
    headerCheckboxSelection: true,
  },
  {
    headerName: "Question ID",
    field: "questionId",
    width: 130,
    filter: true,
  },
  {
    headerName: "Question",
    field: "questionPlainText",
    width: 200,
    filter: true,
    tooltipField: "questionPlainText",
    cellRendererFramework: (params) => <QuestionCellViewModal value={params.value} />
  },
  {
    headerName: "Subject",
    field: "subject",
    filter: true,
  },
  { headerName: "Question Status", field: "questionStatus", filter: true },
  {
    headerName: "Question Complexity",
    field: "questionComplexity",
    filter: true,
  },
  // {
  //   headerName: "Created By",
  //   field: "createdBy",
  //   filter: true,
  // },
  // {
  //   headerName: "Created Date",
  //   field: "createdDate",
  //   valueFormatter: (createdDate) => {
  //     return createdDate ? moment(createdDate).format("DD-MM-YYYY hh:mm A") : '';
  //   },
  //   filter: true,
  // },
  {
    headerName: "Updated By",
    field: "updatedBy",
    filter: true,
  },
  {
    headerName: "Updated Date",
    field: "updatedDate",
    valueFormatter: (updatedDate) => {
      return updatedDate ? moment(updatedDate.value).format("DD-MM-YYYY hh:mm A") : '';
    },
    filter: true,
  },
  {
    headerName: "Actions",
    field: "",
    filter: true,
  },
];

export const searchColumnDefs = [
  {
    headerName: "",
    field: "",
    checkboxSelection: true,
    width: 40,
    headerCheckboxSelection: true,
  },
  {
    headerName: "Question ID",
    field: "questionId",
    width: 130,
    filter: true,
  },
  {
    headerName: "Question",
    field: "questionPlainText",
    width: 200,
    filter: true,
    tooltipField: "questionPlainText",
    cellRendererFramework: (params) => <QuestionCellViewModal value={params.value} />
  },
  {
    headerName: "Subject",
    field: "subject",
    filter: true,
  },
  { headerName: "Question Status", field: "questionStatus", filter: true },
  {
    headerName: "Question Complexity",
    field: "questionComplexity",
    filter: true,
  },
  // {
  //   headerName: "Created By",
  //   field: "createdBy",
  //   filter: true,
  // },
  // {
  //   headerName: "Created Date",
  //   field: "createdDate",
  //   valueFormatter: (createdDate) => {
  //     return createdDate ? moment(createdDate).format("DD-MM-YYYY hh:mm A") : '';
  //   },
  //   filter: true,
  // },
  {
    headerName: "Updated By",
    field: "updatedBy",
    filter: true,
  },
  {
    headerName: "Updated Date",
    field: "updatedDate",
    valueFormatter: (updatedDate) => {
      return updatedDate ? moment(updatedDate.value).format("DD-MM-YYYY hh:mm A") : '';
    },
    filter: true,
  },
  {
    headerName: "Actions",
    field: "",
    filter: true,
  },
];

export const fields = {
  QUESTION_ID: "questionId",
  ACTIONS: "Actions",
};

export const popupMessages = {
  APPROVE_POPUP_MESSAGE:
    "Exam will not be edited once you Approve. Are you sure you want to continue?",
};
export const auditColumnDefs = [
  {
    headerName: "Question ID",
    field: "questionId",
  },
  // {
  //   headerName: "Question",
  //   field: "questionPlainText",
  //   width: 200,
  //   filter: true,
  //   tooltipField: "questionPlainText",
  // },
  {
    headerName: "Updated Status",
    field: "newStatus",
  },
  {
    headerName: "Comment",
    field: "comment",
    cellRenderer: (params) => {
      return getMultiLineStringForDisplayInGrid(params?.data?.comment || "");
    },
  },
  {
    headerName: "Changed By",
    field: "createdBy",
  },
  {
    headerName: "Changed Date",
    field: "createdDate",
    valueFormatter: (createdDate) => {
      return createdDate ? moment(createdDate.value).format("DD-MM-YYYY hh:mm A") : '';
    },
  },
];

export const examInfoColumnDefs = (handleOpen) => {
  return [
  {
    headerName: "",
    field: "",
    checkboxSelection: true,
    width: 40,
    headerCheckboxSelection: true,
  },
  { headerName: "Exam ID", field: "examId", filter: true, width: 120 },
  {
    headerName: "Exam",
    field: "examName",
    filter: true,
  },
  { headerName: "Branch", field: "branch", filter: true },
  { headerName: "Batch", field: "batch", filter: true },
  {
    headerName: "Status",
    field: "status",
    filter: true,
  },
  { headerName: "Subject", field: "subject", filter: true },
  { headerName: "Exam Category", field: "examCategory", filter: true },
  { headerName: "Complexity", field: "examType", filter: true },
  {
    headerName: "Exam Creation Type",
    field: "examCreationType",
    filter: true,
  },
  {
    headerName: "Exam Fee(INR)",
    field: "examCost",
    filter: true,
  },
  {
    headerName: "Created By",
    field: "createdBy",
    filter: true,
  },
  {
    headerName: "Created Date",
    field: "createdDate",
    filter: true,
    cellRenderer: (params) => {
      
      return moment(params.value).format("DD-MM-YYYY hh:mm A");
    },
  },
  {
    headerName: "Updated By",
    field: "updatedBy",
    filter: true,
  },
  {
    headerName: "Updated Date",
    field: "updatedDate",
    filter: true,
    cellRenderer: (params) => {
      // put the value in bold
      return moment(params.value).format("DD-MM-YYYY hh:mm A");
    },
  },
  {
    headerName: "Comments",
    field: "comments",
    filter: true,
    cellRendererFramework: (params) => {
      // put the value in bold
      return <Button onClick={() => { handleOpen(params) }}
        style={{ cursor: "pointer" }}>
        View
      </Button>
    }
  },
]};

export const examDetailTableViewColumnDefs = [
  {
    headerName: "Question ID",
    field: "questionMap.questionId",
    width: 40,
    filter: true,
  },
  { headerName: "Question", field: "questionMap.question", filter: true },
];

export const createEditExamColumnDefs = [
  {
    headerName: "",
    field: "",
    checkboxSelection: true,
    width: 20,
    headerCheckboxSelection: true,
  },
  {
    headerName: "Question ID",
    field: "questionMap.questionId",
    filter: true,
    width: 40,
  },
  {
    headerName: "Question",
    field: "questionMap.question",
    filter: true,
  },
];

export const createExamColumnDefs = [
  {
    headerName: "",
    field: "",
    checkboxSelection: true,
    width: 40,
    headerCheckboxSelection: true,
  },
  {
    headerName: "Question ID",
    field: "questionId",
    filter: true,
  },
  {
    headerName: "Question",
    field: "questionPlainText",
    width: 200,
    filter: true,
    tooltipField: "questionPlainText",
    cellRendererFramework: (params) => <QuestionCellViewModal value={params.value} />
  },
  { headerName: "subject", field: "subject" },
  // { headerName: 'Where Used', field: 'questionId', filter: true },
  {
    headerName: "Changed By",
    field: "createdBy",
  },
  {
    headerName: "Changed Date",
    field: "createdDate",
    cellRenderer: (params) => {
      // put the value in bold
      return moment(params.value).format("DD-MM-YYYY hh:mm A");
    },
  },
  {
    headerName: "Updated By",
    field: "updatedBy",
  },
  {
    headerName: "Updated Date",
    field: "updatedDate",
    cellRenderer: (params) => {
      // put the value in bold
      return moment(params.value).format("DD-MM-YYYY hh:mm A");
    },
  },
  { headerName: "Question Status", field: "questionStatus", filter: true },
];

export const WhereUsedColumnDefs = [
  { headerName: "Exam Name", field: "exam", filter: true },

  {
    headerName: "Batch",
    field: "batch",
    filter: true,
  },
  {
    headerName: "Branch",
    field: "branch",
    filter: true,
  },
  {
    headerName: "Created By",
    field: "createdBy",
    filter: true,
  },
  {
    headerName: "Exam Created Date",
    field: "examCreatedDate",
    filter: true,
  },
];

export const FeedbackColumnDefs = [
  { headerName: "Exam Name", field: "name", filter: true },
  { headerName: "Batch", field: "batch", filter: true },
  { headerName: "Branch", field: "branch", filter: true },
  { headerName: "Created By", field: "createdBy", filter: true },
  { headerName: "Exam Created Date", field: "examCreatedDate", filter: true },
  { headerName: "Comments", field: "comments", filter: true },
  { headerName: "Created Date", field: "createdDate", filter: true },
  { headerName: "Error Reported", field: "errorReported", filter: true },
  { headerName: "Library Type", field: "libType", filter: true },
  { headerName: "Question ID", field: "questionId", filter: true },
  { headerName: "Status", field: "status", filter: true },
  { headerName: "Student Email", field: "studentEmail", filter: true },
  { headerName: "Unique ID", field: "uniqueId", filter: true },
];

export const examInfoColumnDefsExamineeRole = [
  { headerName: "Exam ID", field: "examId", filter: true },
  {
    headerName: "Exam",
    field: "examName",
    filter: true,
  },
  {
    headerName: "Total Questions",
    field: "totalQuestions",
    filter: true,
  },
  {
    headerName: "Action",
    field: "action",
    filter: true,
  },
];

export const status = {
  APPROVED: "APPROVED",
  SENT_FOR_APPROVAL: "SENT FOR APPROVAL",
  SAVED: "SAVED",
  CORRECTION_NEEDED: "NEED CORRECTION",
  REJECTED: "REJECTED",
};
export const status_colors = {
  APPROVED: "#19D2AC",
  SENT_FOR_APPROVAL: "yellow",
  SAVED: "grey",
  CORRECTION_NEEDED: "#FFB347",
  REJECTED: "#ED3817",
};

export const pageTitles = {
  EXAM_DETAIL_VIEW: "Exam Detail View",
  EDIT_EXAM: "Edit Exam",
};
export const defaultDisableButtonsObject = {
  APPROVED: { disable: true, Message: "Please select a record" },
  REJECTED: { disable: true, Message: "Please select a record" },
  "SENT FOR APPROVAL": { disable: true, Message: "Please select a record" },
  "NEED CORRECTION": { disable: true, Message: "Please select a record" },
};

export const examInfoDetails = {
  DEACTIVATE_VALUE: "No",
  ACTIVATE_VALUE: "Yes",
  DEACTIVATE: "Deactivate",
  ACTIVATE: "Activate",
};

export const toasterMessages = {
  SUCCESS: {
    APPROVED: "Exam approved successfully",
    "SENT FOR APPROVAL": "Exam sent for approval successfully",
    SAVED: "Exam saved successfully",
    ZOOM: "Successfully Joined",
    ZOOM_SUCCESS: "Successfully Updated",
  },
  FAIL: {
    DEFAULT: "Unable to perform operation. Please try again later",
  },
};

export const ADMIN_TABS_CONFIGURATION = {
  COURSES: {
    inputs: [
      {
        inputType: "text",
        labelName: "Course Name",
        isMandatory: "Y",
        validateWithExistingData: "Y",
        existingDataSetKey: "coursesList",
        name: "course",
      },
    ],
    info: {
      idColumn: "courseId",
      servicePath: "admin/saveCourse",
      toasterMsg: "Course created successfully",
    },
    delete: {
      servicePath: "admin/deleteCourse",
      toasterMsg: "Course deleted successfully",
      httpMethod: "DELETE",
    },
  },
  SUBJECTS: {
    inputs: [
      {
        inputType: "text",
        labelName: "Subject Name",
        isMandatory: "Y",
        validateWithExistingData: "Y",
        existingDataSetKey: "subjectsList",
        name: "subject",
      },
      {
        inputType: "text",
        labelName: "Thumbnail URL",
        isMandatory: "N",
        validateWithExistingData: "N",
        existingDataSetKey: "subjectsList",
        name: "thumbnailUrl",
      },
      {
        inputType: "text",
        labelName: "Year Taught",
        isMandatory: "N",
        validateWithExistingData: "N",
        existingDataSetKey: "subjectsList",
        name: "yearTaught",
      },
    ],
    info: {
      idColumn: "subjectId",
      servicePath: "admin/saveSubject",
      toasterMsg: "Subject created successfully",
    },
    delete: {
      servicePath: "admin/deleteSubject",
      toasterMsg: "Subject deleted successfully",
      httpMethod: "DELETE",
    },
  },
  BRANCH: {
    inputs: [
      {
        inputType: "text",
        labelName: "Branch Name",
        isMandatory: "Y",
        validateWithExistingData: "Y",
        existingDataSetKey: "branchesList",
        name: "branchName",
      },
      {
        inputType: "text",
        labelName: "Branch Address",
        isMandatory: "N",
        name: "branchAddress",
      },
      {
        inputType: "text",
        labelName: "Branch State",
        isMandatory: "N",
        name: "branchState",
      },
      {
        inputType: "text",
        labelName: "Branch Country",
        isMandatory: "N",
        name: "branchCountry",
      },
      {
        inputType: "text",
        labelName: "Branch Email",
        isMandatory: "N",
        validatePattern: "Y",
        pattern: /^\S+@\S+[.]+\S+$/,
        patternErrorMsg: "The email id doesn't seem right ",
        name: "branchEmail",
      },
    ],
    info: {
      idColumn: "branchId",
      servicePath: "admin/saveBranch",
      toasterMsg: "Branch created successfully",
    },
    delete: {
      servicePath: "admin/deleteBranch",
      toasterMsg: "Branch deleted successfully",
      httpMethod: "DELETE",
    },
  },
  BATCH: {
    inputs: [
      {
        inputType: "text",
        labelName: "Batch ID",
        isMandatory: "Y",
        validateWithExistingData: "Y",
        existingDataSetKey: "batchesList",
        validatePattern: "Y",
        pattern: /^[a-z\d\-_\s]+$/i,
        patternErrorMsg: "The batch id cannot contain special characters",
        name: "batchId",
      },
      {
        inputType: "text",
        labelName: "Batch Name",
        isMandatory: "Y",
        validateWithExistingData: "Y",
        existingDataSetKey: "batchesList",
        name: "batch",
      },
      {
        inputType: "text",
        labelName: "Batch Description",
        isMandatory: "Y",
        validateWithExistingData: "Y",
        existingDataSetKey: "batchesList",
        name: "batchDescription",
      },
      {
        inputType: "select",
        labelName: "Branch",
        isMandatory: "Y",
        validateErrorMsg: "Branch is required",
        name: "branchId",
        values: "branchesList",
        optionValue: "branchName",
        optionKey: "branchId",
      },
      {
        inputType: "select",
        labelName: "App Display",
        isMandatory: "Y",
        validateErrorMsg: "App Display is required",
        name: "appDisplay",
        values: "confirm",
        optionValue: "key",
        optionKey: "value",
      },
      {
        inputType: "date",
        labelName: "Start Date",
        isMandatory: "N",
        validateWithExistingData: "Y",
        excludeMinValue: true,
        name: "startDate",
      },
      {
        inputType: "date",
        labelName: "End Date",
        isMandatory: "N",
        validateWithExistingData: "Y",
        validateErrorMsg: "End date must be greater than Start date",
        minDateValue: "startDate",
        name: "endDate",
      },
    ],
    info: {
      servicePath: "admin/saveBatch",
      toasterMsg: "Batch created successfully",
    },
    delete: {
      servicePath: "admin/deleteBatch",
      toasterMsg: "Batch deleted successfully",
      httpMethod: "DELETE",
    },
  },
  TOPICS: {
    inputs: [
      {
        inputType: "text",
        labelName: "Topic Name",
        isMandatory: "Y",
        validateWithExistingData: "Y",
        existingDataSetKey: "topicList",
        name: "topic",
      },
      {
        inputType: "select",
        labelName: "Subject",
        isMandatory: "Y",
        validateErrorMsg: "Subject is required",
        name: "subjectId",
        values: "subjectsList",
        optionValue: "subject",
        optionKey: "subjectId",
      },
    ],
    info: {
      idColumn: "topicId",
      servicePath: "admin/saveTopic",
      toasterMsg: "Topic created successfully",
    },
    delete: {
      servicePath: "admin/deleteTopic",
      toasterMsg: "Topic deleted successfully",
      httpMethod: "DELETE",
    },
  },
  BATCH_DESCRIPTION: {
    inputs: [
      {
        inputType: "select",
        labelName: "Batch",
        isMandatory: "Y",
        validateErrorMsg: "Batch is required",
        name: "batchId",
        values: "batchesList",
        optionValue: "batch",
        optionKey: "batchId",
      },
      {
        inputType: "textarea",
        labelName: "Batch Description",
        isMandatory: "Y",
        validateWithExistingData: "Y",
        existingDataSetKey: "description",
        name: "batchDescription",
      }

    ],
    info: {
      servicePath: "admin/saveBatchDescription",
      toasterMsg: "Description updated successfully",
    }
  },
  TAGS: {
    inputs: [
      {
        inputType: "text",
        labelName: "Tag Name",
        isMandatory: "Y",
        validateWithExistingData: "Y",
        existingDataSetKey: "tagList",
        name: "tagName",
      },
    ],
    info: {
      idColumn: "tagId",
      servicePath: "admin/saveTag",
      toasterMsg: "Tag created successfully",
    },
    delete: {
      servicePath: "admin/deleteTags",
      toasterMsg: "Tag deleted successfully",
      httpMethod: "DELETE",
    },
  },
  USERS: {
    inputs: [
      {
        inputType: "text",
        labelName: "First Name",
        isMandatory: "Y",
        name: "firstName",
      },
      {
        inputType: "text",
        labelName: "Last Name",
        isMandatory: "Y",
        name: "lastName",
      },
      {
        inputType: "email",
        labelName: "Email",
        isMandatory: "Y",
        validateWithExistingData: "Y",
        existingDataSetKey: "usersList",
        validatePattern: "Y",
        pattern: /^\S+@\S+[.]+\S+$/,
        patternErrorMsg: "The email id doesn't seem right ",
        name: "email",
      },
      {
        inputType: "password",
        labelName: "Password",
        isMandatory: "Y",
        validatePattern: "Y",
        pattern: /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
        patternErrorMsg:
          "Password must contain 8 characters, contains at least 1 numeric character, 1 special character, 1 uppercase letter and 1 lowercase letter",
        name: "password",
      },
      {
        inputType: "multi-select",
        labelName: "Role",
        isMandatory: "Y",
        validateErrorMsg: "Role is required",
        name: "roleId",
        values: "rolesList",
        optionValue: "roleName",
        optionKey: "roleId",
      },
    ],
    info: {
      idColumn: "userId",
      servicePath: "usermanagement/saveUser",
      toasterMsg: "User created successfully",
    },
    delete: {
      servicePath: "usermanagement/deleteUser",
      toasterMsg: "User deleted successfully",
      httpMethod: "DELETE",
    },
  },
  USER_SUBJECT_MAP: {
    inputs: [
      {
        inputType: "select",
        labelName: "User Email",
        isMandatory: "Y",
        validateErrorMsg: "User Email is required",
        name: "userId",
        values: "usersList",
        optionValue: "email",
        optionKey: "userId",
      },
      {
        inputType: "select",
        labelName: "Subject",
        isMandatory: "Y",
        validateErrorMsg: "Subject is required",
        name: "subjectId",
        values: "subjectsList",
        optionValue: "subject",
        optionKey: "subjectId",
      },
    ],
    info: {
      servicePath: "usermanagement/MapUserToSubject",
      toasterMsg: "User entrolled for subject successfully",
    },
    delete: {
      servicePath: "usermanagement/deleteUserFromSubject",
      toasterMsg: "User deleted from subject successfully",
      httpMethod: "DELETE",
    },
  },
  USER_EXAM_MAP: {
    inputs: [
      {
        inputType: "select",
        labelName: "User Email",
        isMandatory: "Y",
        validateErrorMsg: "User Email is required",
        name: "userId",
        values: "usersList",
        optionValue: "email",
        optionKey: "userId",
      },
      {
        inputType: "select",
        labelName: "Exam Name",
        isMandatory: "Y",
        validateErrorMsg: "Exam Name is required",
        name: "examId",
        values: "examsList",
        optionValue: "examName",
        optionKey: "examId",
      },
    ],
    info: {
      servicePath: "mapUsertoExam",
      toasterMsg: "User entrolled for exam successfully",
      requiredFieldsforPayload: {
        questions_attempted: 0,
        questions_correct: 0,
        time_taken: null,
        exam_status: "ENROLLED",
      },
    },
  },
};
